import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReportsOperations from './ReportsOperations';
import { fetchReports, deleteReport } from 'redux/report/ReportActions';

const mapStateToProps = ({ reports }) => ({
  fetchingReports: reports.fetchingReports,
  reports: reports.reports,
  pageState: reports.pageState,
  generatingReport: reports.generatingReport
});

const mapDispatchToProps = dispatch => ({
  reportsActions: bindActionCreators({ fetchReports, deleteReport }, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(ReportsOperations);



// WEBPACK FOOTER //
// ./src/components/manageReports/comp/reportsOperations/ReportsOperationsConnector.js